import "./index.scss";
import React, {useContext, useEffect, useState} from "react";
import {EntryFormGroup} from "../EntryFormGroup";
import {EntryFormItem} from "../EntryFormItem";
import {FormProvider, useForm} from "react-hook-form";
import {
    filterPages,
    sortPagesAndCreateDefaultValues
} from "../../helper";
import {GlobalContext} from "../../context";

export function ResultsMenu({isTabletOrMobile, collapsed}) {
    const [sortedPages, setSortedPages] = useState([]);
    const [filteredPages, setFilteredPages] = useState([]);
    const [values, setValues] = useState();
    const formMethods = useForm({values, reValidateMode: 'onChange'});
    const {/*config, */pages, updateCookies, goToResults, responseArray} = useContext(GlobalContext);
    // const {imprintLink, agbLink, privacyLink} = config;

    useEffect(() => {
        if (!pages || pages.length === 0) {
            return;
        }
        console.log('updating pages', {pages});
        // TODO: also add current responseArray values to defaultValues
        sortPagesAndCreateDefaultValues(pages)
            .then(({sortedPages, defaultValues}) => {
                console.log('updating pages - finished', {sortedPages, defaultValues});
                setSortedPages(sortedPages);
                setValues(defaultValues);
            });
    }, [pages, setSortedPages, formMethods]);

    useEffect(() => {
        if (!sortedPages || sortedPages.length === 0) {
            return;
        }
        console.log('updating filtered pages', {sortedPages, responseArray});
        filterPages(sortedPages, responseArray)
            .then(filteredPages => {
                setFilteredPages(filteredPages);
                // TODO: reactivate after adding current responseArray values
                // setTimeout(() => formMethods.trigger(), 100);
            });
    }, [sortedPages, responseArray, setFilteredPages, formMethods.trigger]);


    if (collapsed) return null;

    return (
        <FormProvider {...formMethods}>
            <form onSubmit={formMethods.handleSubmit(
                () => handleSubmit(responseArray, updateCookies, goToResults),
                () => handleError(responseArray),
            )}>
                <div
                    className={`results-menu d-flex flex-column mt-3`}
                >
                    <div
                        className={`rm-content d-flex ${isTabletOrMobile ? 'flex-row flex-wrap' : 'flex-column flex-nowrap'}`}
                    >
                        {/*{filteredPages.map((group, groupIndex) => (*/}
                        {/*    <EntryFormGroup*/}
                        {/*        key={groupIndex}*/}
                        {/*        icon={group.icon}*/}
                        {/*        title={group.name}*/}
                        {/*    >*/}
                        <div className="efg-container">
                                {filteredPages.map((entry, entryIndex) => (
                                    <EntryFormItem
                                        key={entryIndex}
                                        page={entry}
                                    />
                                ))}
                        </div>
                        {/*    </EntryFormGroup>*/}
                        {/*))}*/}
                    </div>
                    {/*<div className="flex-grow-1">&nbsp;</div>*/}
                    {/*<div className="rm-footer d-flex flex-row flex-nowrap">*/}
                    {/*    <div className="mr-3 rmf-link">*/}
                    {/*        <a href={imprintLink || agbLink} target="_blank">Impressum</a>*/}
                    {/*    </div>*/}
                    {/*    <div className="rmf-link">*/}
                    {/*        <a href={privacyLink} target="_blank"> Datenschutz</a>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </form>
        </FormProvider>
    )
}